import { Navigate, Outlet } from "react-router-dom";

interface ProtectedRouteProps {
  allowedUserType: ("D"|"P"|"C"); 
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedUserType }) => {
  const userType = sessionStorage.getItem("userType") as "D" | "P" | "C" | null;

  if (!userType) {
    return <Navigate to="/login" replace />;
  }
  return allowedUserType.includes(userType) ? <Outlet/> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
